import { DbCategory } from '@/hooks/useMenuData';

interface CategoryNavProps {
  categories: DbCategory[];
  activeCategory: string;
  onSelect: (id: string) => void;
  itemCounts: Record<string, number>;
}

const CategoryNav = ({ categories, activeCategory, onSelect, itemCounts }: CategoryNavProps) => {
  return (
    <nav className="flex flex-col gap-1 py-2">
      {categories.map((cat) => {
        const isActive = activeCategory === cat.id;
        return (
          <button
            key={cat.id}
            onClick={() => onSelect(cat.id)}
            className={`group flex items-center gap-3 px-4 py-3 rounded-xl text-left transition-all duration-200 cursor-pointer w-full ${
              isActive
                ? 'bg-amber-500 text-white'
                : 'text-stone-600 hover:bg-stone-100 hover:text-stone-900'
            }`}
          >
            <div className={`w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0 transition-all ${
              isActive ? 'bg-white/20' : 'bg-stone-100 group-hover:bg-stone-200'
            }`}>
              <i className={`${cat.icon} text-base ${isActive ? 'text-white' : 'text-stone-500'}`}></i>
            </div>
            <div className="flex-1 min-w-0">
              <div className={`font-semibold text-sm leading-tight ${isActive ? 'text-white' : 'text-stone-800'}`}>
                {cat.name_de}
              </div>
              <div className={`text-xs mt-0.5 ${isActive ? 'text-white/70' : 'text-stone-400'}`}>
                {itemCounts[cat.id] ?? 0} Artikel
              </div>
            </div>
            {isActive && (
              <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-arrow-right-s-line text-white text-base"></i>
              </div>
            )}
          </button>
        );
      })}
    </nav>
  );
};

export default CategoryNav;
